<template>
  <b-nav class="main-nav">
    <b-nav-item class="logo">
      <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <div class="main-div">
      <div class="login-div">
          <p>Email address not registered. Would you like to Register with us? <br><br>
            <b-button
              type="reset"
              @click="register()"
              class="w-100"
              variant="warning">Register Now</b-button>
            </p>
      </div>
    </div>
  </b-nav>
</template>

<script>
import FacitHeader from '@/components/header';

export default {
  name: 'Verification',
  components: { FacitHeader },
  data() {
    return {

    };
  },
  methods: {
    register() {
      this.$router.push('registration');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  margin-top: 20px;
  width: 80%;
  margin-left: 30px;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
  text-align: center;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.w-100 {
  width: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/notification.vue